import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { Navigation } from '../../../../core/navigation';

import { IonImgCacheService } from '../../../ionic2-img-cache/ion-img-cache';
import { Storage } from '@ionic/storage';

@Component({
	selector: 'page-menu-more',
  	templateUrl: 'menu-more.html'
})

export class MenuMorePage extends PageBase {
	public menuSections: any;

  	constructor(
		public settings: AppSettings,
		public events: Events,
		public nav: NavController,
		public userData: UserData,
		public menu: Navigation,
		public storage: Storage,
		public imgCache: IonImgCacheService
	) {
		super(settings, events, nav, userData);
		let self = this;

		menu.getData('more').subscribe((nav)=>{
			console.log("Navigation Loaded: ", nav.name);	
			self.menuSections = nav.sections;
		});	
	}

	public openPage(menuItem){
		switch (menuItem.type) {
		  case "inapp":
		    this.nav.setRoot(this.pageRef.get(menuItem.link), menuItem.param);        
		    break;

		  case "web":
		    window.open(menuItem.link, '_blank', 'location=no,closebuttoncaption=Close,toolbarposition=top');
		    break;

		  case "dynamic-page":
		    // this.nav.setRoot(DynamicPage, {name: menuItem.link});
		    break;
		  
		  default:
		    // code...
		    break;
		}
	}

	public clearCache(){
		console.log('clearCache');
		this.imgCache.clearCache();
		this.storage.clear();
	}

}


// WEBPACK FOOTER //
// ./src/modules/menu-more/pages/menu-more/menu-more.ts